import React from "react";

import { Jsme } from "jsme-react";
import {
  Col,
  Row,
  Container,
  Form,
  Button,
  Table,
  PageItem,
  Modal,
  Spinner,
  Collapse,
  Accordion,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Card,
  Tab,
  Tabs,
} from "react-bootstrap";
import axios from "axios";
import initRDKit from "../layout/utils/initRDKit";
import { useSearchParams } from "react-router-dom";
import Base from "../layout/BaseTemplate";
import MoleculeSVG from "../RDKIT/Molecule";

function Bioisosteres() {
  let [searchParams, setSearchParams] = useSearchParams();
  const [rdKit, setRdKit] = React.useState(null);
  const [smiles, setSmiles] = React.useState(
    searchParams.get("smiles") ? searchParams.get("smiles") : ""
  );
  const [smilestxt, setSmilestxt] = React.useState(
    searchParams.get("smiles") ? searchParams.get("smiles") : ""
  );

  const [task, setTask] = React.useState(
    searchParams.get("task") ? searchParams.get("task") : null
  );

  const [results, setResults] = React.useState([]);

  const [molwtup, setMolwtup] = React.useState(true);
  const [molwtdown, setMolwtdown] = React.useState(true);
  const [logpup, setLogpup] = React.useState(true);
  const [logpdown, setLogpdown] = React.useState(true);

  const [spin, setSpin] = React.useState(false);
  const [isReady, setIsReady] = React.useState(false);
  const [count, setCount] = React.useState(1);
  const [molWt, setMolWt] = React.useState(null);
  const [logP, setLogP] = React.useState(null);

  function downloadTXT() { }

  React.useEffect(() => {
    if (!rdKit) {
      initRDKit().then((rd) => {
        setRdKit(rd);
      });
    }
  }, []);

  React.useEffect(() => { }, [smilestxt]);

  React.useEffect(() => {
    if (task === "") {
      return;
    }
    setSpin(true);
    setIsReady(false);
    function getProgress() {
      return axios.get("/results/" + task).then((result) => {
        console.log(result.data);
        if (result.data.ready) {
          console.log(result.data);
          setResults(result.data.results[0].results);
          // writesmiles(result.data.results[0].smiles, false, true);

          setLogP(result.data.results[0].logP);
          setMolWt(result.data.results[0].molWt);
          setSpin(false);
          setIsReady(true);
        } else {
          //sleep for .5 seconds

          setTimeout(() => { }, 500);
          getProgress();
        }
      });
    }

    getProgress();
  }, [task]);

  function showspinner() {
    if (spin === true) {
      return <Spinner animation="grow" variant="info" />;
    } else {
      return;
    }
  }

  function submitTask() {
    var bodyFormData = new FormData();

    bodyFormData.append("smiles", smilestxt);
    bodyFormData.append("weightUp", molwtup);
    bodyFormData.append("weightDown", molwtdown);
    bodyFormData.append("logUp", logpup);
    bodyFormData.append("logDown", logpdown);
    bodyFormData.append("count", count);

    setSpin(true);
    setIsReady(false);
    axios({
      url: "/bioisostere/transform",
      method: "post",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    }).then((response) => {
      console.log(response.data);
      setTask(response.data.task_id);
    });
  }

  React.useEffect(() => {
    if (results.length > 0) {
      results.map((result, index) => {
        result["gen" + String(index + 1)].map((result, index) => {
          var canvas = document.getElementById("canvas-" + result.smiles);
          if (canvas === null) {
            return;
          }
          rdKit.get_mol(result.smiles).draw_to_canvas(canvas, 100, 100);
          return "";
        });
      });
    }
  }, [results]);

  function showResults(gen) {
    if (results.length === 0) {
      return <tr>No results</tr>;
    } else {
      let res = results[gen];

      res = res["gen" + String(gen + 1)];

      return res.map((result, index) => {
        return (
          <tr key={index}>
            <td>
              <canvas
                height={100}
                width={100}
                id={"canvas-" + result.smiles}
              ></canvas>
            </td>
            <td>{result.smiles}</td>
            <td>{result.transform_name}</td>
            <td>{result.molW}</td>
            <td>{result.logP}</td>
          </tr>
        );
      });
    }
  }

  function writesmiles(smiles, fromJSME = false, fromText = false) {
    if (fromJSME) {
      setSmilestxt(smiles);
    } else if (fromText) {
      setSmilestxt(smiles);
      setSmiles(smiles);
    }
  }

  return (
    <Base>
      <Row>
        <Col className="p-1" lg={6} md={6} sm={12}>
          <Card className="p-2">
            <Form onSubmit={submitTask}>
              <Form.Group>
                <Row>
                  <Col lg={9} md={9} sm={9}>
                    <Jsme
                      src="/jsme/jsme.nocache.js"
                      height="20rem"
                      width="auto"
                      options={"noautoez,newlook,nocanonize,multipart,zoom"}
                      smiles={
                        rdKit && rdKit.get_mol(smiles)
                          ? rdKit.get_mol(smiles).get_smiles()
                          : smiles
                      }
                      onChange={(smiles) => writesmiles(smiles, true, false)}
                    />
                    <Form.Group>
                      <Form.Label>
                        <b>SMILES</b>{" "}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={smilestxt}
                        onChange={(e) =>
                          writesmiles(e.target.value, false, true)
                        }
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>
                        <b>Transform Count</b>{" "}
                      </Form.Label>
                      <Form.Select
                        onChange={(e) => setCount(e.target.value)}
                        value={count}
                      >
                        {[1, 2, 3].map((count) => {
                          return (
                            <option key={count} value={count}>
                              {count}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                    <br></br>
                    <Button variant="info" onClick={submitTask}>
                      Transform
                    </Button>{" "}
                  </Col>
                  <Col>
                    <Form.Label>
                      <u>Weight Filter</u>
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                      label="▲ MolW"
                      checked={molwtup}
                      onChange={(e) => setMolwtup(e.target.checked)}
                    />
                    <Form.Check
                      type="checkbox"
                      label="▼ MolW"
                      checked={molwtdown}
                      onChange={(e) => setMolwtdown(e.target.checked)}
                    />
                    <br></br>
                    <Form.Label>
                      <u>LogP Filter</u>
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                      label="▲ LogP"
                      checked={logpup}
                      onChange={(e) => setLogpup(e.target.checked)}
                    />
                    <Form.Check
                      type="checkbox"
                      label="▼ LogP"
                      checked={logpdown}
                      onChange={(e) => setLogpdown(e.target.checked)}
                    />
                    <br></br>
                    {logP ? (
                      <Form.Label>
                        <b>LogP</b> {logP}
                      </Form.Label>
                    ) : (
                      ""
                    )}
                    <br></br>
                    {molWt ? (
                      <Form.Label>
                        <b>MolWt</b> {molWt}
                      </Form.Label>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Form.Group>
            </Form>
            <br></br>
          </Card>
        </Col>

        <Col lg={6} md={6} sm={12} className="p-1 m-0">
          <div className="overflow-auto" style={{ maxHeight: "650px" }}>
            <Tabs>
              {results &&
                results.map((result, index) => {
                  return (
                    <Tab
                      eventKey={index}
                      title={"Gen " + String(index + 1)}
                      key={index}
                    >
                      <Table table-light striped bordered hover size="sm">
                        <thead>
                          <th>&nbsp;</th>
                          <th>Smiles</th>
                          <th>Transform</th>
                          <th>MW</th>
                          <th>LogP</th>
                        </thead>
                        <tbody>
                          {isReady ? showResults(index) : showspinner()}
                        </tbody>
                      </Table>
                    </Tab>
                  );
                })}
              {/* <Table table-light striped bordered hover size="sm">
                <thead>
                  <th>&nbsp;</th>
                  <th>Smiles</th>
                  <th>Transform</th>
                  <th>MW</th>
                  <th>LogP</th>
                </thead>
                <tbody>{isReady ? showResults(0) : showspinner()}</tbody> */}
            </Tabs>
          </div>
        </Col>
      </Row>
    </Base>
  );
}

export default Bioisosteres;
